import moment from 'moment';
import { URL_ORGANIZATION_BUSINESS_INPUT_DOWNLOAD } from '@tools/routes/routes';

export function monthAndYear(input) {
  let date = null;
  if (input) {
    date = input;
    if (!(input instanceof Date) && input.unix) {
      date = new Date(input.unix * 1000);
    }

    const month = new Intl.DateTimeFormat('fr-FR', { month: 'short' }).format(date).trim();
    return `${month}\u00A0${date.getFullYear()}`;
  }

  return '';
}

export const adafMixins = {
  methods: {
    monthAndYear,
    displayedMonthLabel(displayDate) {
      if (displayDate !== null) {
        return `${new Intl.DateTimeFormat('fr-FR', {
          month: 'long',
        }).format(displayDate)} ${displayDate.getFullYear()}`;
      }
      return '';
    },
    isThisCurrentMonth(displayDate) {
      const now = new Date();
      return (
        now.getMonth() === displayDate.getMonth()
        && now.getFullYear() === displayDate.getFullYear()
      );
    },
    downloadCurrentMonth() {
      const month = moment(this.displayDate);
      const url = URL_ORGANIZATION_BUSINESS_INPUT_DOWNLOAD.replace(
        '%start_month%',
        month.format('YYYYMM'),
      ).replace('%end_month%', month.format('YYYYMM'));
      window.open(url);
    },
    downloadLast12Months() {
      const month = moment();
      const lastYear = moment(month).add(-1, 'year');
      const url = URL_ORGANIZATION_BUSINESS_INPUT_DOWNLOAD.replace(
        '%start_month%',
        lastYear.format('YYYYMM'),
      ).replace('%end_month%', month.format('YYYYMM'));
      window.open(url);
    },
    downloadWithCustomDates(startMonth, endMonth) {
      const url = URL_ORGANIZATION_BUSINESS_INPUT_DOWNLOAD.replace(
        '%start_month%',
        startMonth.format('YYYYMM'),
      ).replace('%end_month%', endMonth.format('YYYYMM'));
      window.open(url);
    },
  },
};
